/* Mahabharata quick-commerce layer: card stepper, ETA badge, sticky cart bar.
   Self-contained; talks to Shopify's standard AJAX cart API and Horizon's
   'cart:update' event. Delete the "Quick commerce" footer section to disable. */
(function () {
  'use strict';
  if (window.__mahaQC) return;
  window.__mahaQC = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ETA_TEXT = 'Ready in 24h';
  var DEBOUNCE_MS = 250;
  var cartMap = {};   // variantId -> { key, qty, unit }
  var cart = null;
  var pending = {};   // variantId -> quantity the customer has tapped to
  var inflight = {};  // variantId -> true while a request is running
  var timers = {};

  function noop() {}

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function hideBarHere() {
    return /\/(cart|checkouts?|products)(\/|$)/.test(location.pathname);
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function buildMap(c) {
    cart = c;
    cartMap = {};
    (c.items || []).forEach(function (it) {
      var id = String(it.variant_id);
      if (!cartMap[id]) cartMap[id] = { key: it.key, qty: 0, unit: it.final_price != null ? it.final_price : (it.price || 0) };
      cartMap[id].qty += it.quantity;
    });
  }

  function serverQty(vid) { return cartMap[vid] ? cartMap[vid].qty : 0; }
  function shownQty(vid) { return pending[vid] !== undefined ? pending[vid] : serverQty(vid); }

  function fetchCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { buildMap(c); render(); return c; });
  }

  function announce(c) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: c, sourceId: 'maha-qc', data: { itemCount: c.item_count, source: 'maha-qc' } }
    }));
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'maha-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2600);
  }

  function setLoading(vid, on) {
    document.querySelectorAll('.maha-stepper[data-variant="' + vid + '"]').forEach(function (s) {
      s.classList.toggle('is-loading', on);
    });
  }

  /* Customer tapped: show the new number immediately, send it shortly after. */
  function requestQty(vid, qty) {
    pending[vid] = Math.max(0, qty);
    render();
    clearTimeout(timers[vid]);
    timers[vid] = setTimeout(function () { flush(vid); }, DEBOUNCE_MS);
  }

  function settle(vid) {
    if (pending[vid] !== undefined && pending[vid] === serverQty(vid)) delete pending[vid];
  }

  function flush(vid) {
    if (inflight[vid] || pending[vid] === undefined) return;
    var target = pending[vid];
    var entry = cartMap[vid];
    if (target === serverQty(vid)) { delete pending[vid]; render(); return; }

    inflight[vid] = true;
    setLoading(vid, true);
    var url = entry ? 'cart/change.js' : 'cart/add.js';
    var body = entry ? { id: entry.key, quantity: target } : { items: [{ id: Number(vid), quantity: target }] };

    fetch(ROOT + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetchCart(); })
      .then(function (c) { announce(c); })
      .catch(function (e) {
        delete pending[vid];
        toast((e && (e.description || e.message)) || 'Could not update your cart');
        return fetchCart().catch(noop);
      })
      .then(function () {
        inflight[vid] = false;
        setLoading(vid, false);
        settle(vid);
        if (pending[vid] !== undefined) flush(vid);   // customer kept tapping mid-request
        else render();
      });
  }

  function cardVariant(card) {
    var qa = card.querySelector('quick-add-component');
    if (!qa || qa.getAttribute('data-quick-add-button') !== 'add') return null;
    var input = qa.querySelector('input[name="id"]');
    if (!input || input.disabled || !input.value) return null;
    return { vid: String(input.value), qa: qa };
  }

  function render() {
    document.querySelectorAll('product-card').forEach(function (card) {
      var info = cardVariant(card);
      if (!info) return;
      var host = info.qa.parentNode;
      if (!host) return;

      if (!host.querySelector(':scope > .maha-eta')) {
        var badge = document.createElement('span');
        badge.className = 'maha-eta';
        badge.textContent = ETA_TEXT;
        host.appendChild(badge);
      }

      var qty = shownQty(info.vid);
      var st = host.querySelector(':scope > .maha-stepper');
      if (qty > 0) {
        if (!st) {
          st = document.createElement('div');
          st.className = 'maha-stepper';
          st.setAttribute('data-variant', info.vid);
          st.innerHTML =
            '<button type="button" class="maha-stepper__btn" data-act="dec" aria-label="Remove one">−</button>' +
            '<span class="maha-stepper__qty" aria-live="polite"></span>' +
            '<button type="button" class="maha-stepper__btn" data-act="inc" aria-label="Add one">+</button>';
          host.appendChild(st);
        }
        setText(st.querySelector('.maha-stepper__qty'), String(qty));
        if (!card.classList.contains('maha-in-cart')) card.classList.add('maha-in-cart');
      } else {
        if (st) st.remove();
        if (card.classList.contains('maha-in-cart')) card.classList.remove('maha-in-cart');
      }
    });
    renderBar();
  }

  /* Bar reflects taps immediately, then corrects to the server's numbers. */
  function barNumbers() {
    var n = cart ? cart.item_count : 0;
    var t = cart ? cart.total_price : 0;
    Object.keys(pending).forEach(function (vid) {
      var e = cartMap[vid];
      if (!e) return;
      var d = pending[vid] - e.qty;
      n += d;
      t += d * e.unit;
    });
    return { n: Math.max(0, n), t: Math.max(0, t) };
  }

  function renderBar() {
    var bar = document.getElementById('maha-cartbar');
    if (!bar) return;
    var nums = barNumbers();
    var show = nums.n > 0 && !hideBarHere();
    if (bar.hidden === show) bar.hidden = !show;
    document.body.classList.toggle('maha-bar-on', show);
    if (!show) return;
    setText(bar.querySelector('.maha-cartbar__count'), nums.n + (nums.n === 1 ? ' item' : ' items'));
    setText(bar.querySelector('.maha-cartbar__total'), money(nums.t));
  }

  function isOurs(node) {
    return node.classList && (node.classList.contains('maha-stepper') || node.classList.contains('maha-eta') || node.classList.contains('maha-toast'));
  }

  /* Stop stepper presses from reaching the card link underneath. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.maha-stepper')) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.maha-stepper__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var vid = btn.closest('.maha-stepper').getAttribute('data-variant');
    requestQty(vid, shownQty(vid) + (btn.getAttribute('data-act') === 'inc' ? 1 : -1));
  }, true);

  /* Re-render when the theme adds cards (filters, pagination, recommendations). */
  var timer = null;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1 && !isOurs(added[j])) {
          clearTimeout(timer);
          timer = setTimeout(render, 120);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  /* Stay in sync with the theme's own add-to-cart and cart drawer. */
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'maha-qc') return;
    fetchCart();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fetchCart(); });
  } else {
    fetchCart();
  }
})();
